import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';

import { HistoryPage } from '../history/history';
import { LoadingPage } from '../loading/loading';
import { SignaturePage } from '../signature/signature';
import { PrintPage } from '../print/print';

import { ConstantsProvider } from '../../providers/constants/constants';
import { ConsultationDataProvider } from '../../providers/consultation-data/consultation-data';
// import { ConsultationDataParserProvider } from '../../providers/consultation-data-parser/consultation-data-parser';
import { ConsultationDisplayProvider } from '../../providers/consultation-display/consultation-display';

import { CloudDataProvider } from '../../providers/cloud-data/cloud-data';
import { DataProvider } from '../../providers/data/data';
import { retry } from 'rxjs/operator/retry';

@Component({
   selector: 'page-verification',
   templateUrl: 'verification.html'
})

export class VerificationPage {

   private mainSymptoms = [];
   private mainRemarks = [];
   private periodSymptoms = [];
   private periodRemarks = [];
   private otherSymptoms = [];
   private otherRemarks = [];

   /** ----- Constructor ----- **/

   constructor(private constants: ConstantsProvider,
      private data: DataProvider,
      private consultationData: ConsultationDataProvider,
      // private consultationParser: ConsultationDataParserProvider,

      private consultationDisplay: ConsultationDisplayProvider,
      private navCtrl: NavController,
      private modalCtrl: ModalController,
      private alertCtrl: AlertController,
      private cloudData: CloudDataProvider
      ) { }


   /** ----- View LifeCycle ----- **/

   ionViewWillEnter() {

     this.data.activeTab = 1;

      console.log(JSON.stringify(this.consultationData.chosenDisps));
      /** Symptoms **/

      this.mainSymptoms = [];
      this.mainRemarks = [];
      this.periodSymptoms = [];
      this.periodRemarks = [];
      this.otherSymptoms = [];
      this.otherRemarks = [];

      // for (let i = 0; i < this.consultationData.chosenSymptom.length; i++) {
      //    let obj = this.consultationData.chosenSymptom[i];
      //    if (obj['name_zh'] == '主訴') {
      //       this.mainSymptoms.push(obj);
      //       this.mainRemarks.push(this.consultationData.chosenSymptomRemark[i]);
      //    }
      //    else if (obj['name_zh'] == 'Lmp' || obj['name_zh'] == 'PMS' || obj['name_zh'] == '帶下') {
      //       this.periodSymptoms.push(obj);
      //       this.periodRemarks.push(this.consultationData.chosenSymptomRemark[i]);
      //    }
      //    else {
      //       this.otherSymptoms.push(obj);
      //       this.otherRemarks.push(this.consultationData.chosenSymptomRemark[i]);
      //    }
      // }

      for (let i = 0; i < this.consultationData.chosenSymptoms.length; i++) {
         let obj = this.data.getSymptomById(this.consultationData.chosenSymptoms[i]);
         if (obj['name_zh'] == '主訴') {
            this.mainSymptoms.push(obj);
            this.mainRemarks.push(this.consultationData.chosenSymptomsRemark[i]);
         }
         else if (obj['name_zh'] == 'Lmp' || obj['name_zh'] == 'PMS' || obj['name_zh'] == '帶下') {
            this.periodSymptoms.push(obj);
            this.periodRemarks.push(this.consultationData.chosenSymptomsRemark[i]);
         }
         else {
            this.otherSymptoms.push(obj);
            this.otherRemarks.push(this.consultationData.chosenSymptomsRemark[i]);
         }
      }
      /** End **/
      this.data.currentStep = 2;

      for(let i = 0; i <this.consultationData.chosenDisps.length; i++){
         let chosenDisp = this.consultationData.chosenDisps[i].data;
         let flattenDisp = this.flattenDisp(chosenDisp);
         for(let j = 0; j < flattenDisp.length; j++){
            if(this.constants.dispRestrictionRules[flattenDisp[j].id] == null)continue;
            let firstTmpId = flattenDisp[j].id;
            for(let k = 0; k < flattenDisp.length; k++){
               let secondTmpId = flattenDisp[k].id;
               if(this.constants.dispRestrictionRules[firstTmpId].indexOf(secondTmpId) > -1){
                  flattenDisp[j]["shouldShowRed"] = true;
                  flattenDisp[k]["shouldShowRed"] = true;
               }
            }
         }
         console.log(flattenDisp);
         let flagIndex = 0;
         for(let j = 0; j < chosenDisp.length; j++){
            let chosenDispData = chosenDisp[j];
            if(chosenDispData.type == "disp-grouped"){
               for(let k = 0; k < chosenDispData.data.length; k++){
                  if(flattenDisp[flagIndex]["shouldShowRed"]){
                     // chosenDispData.Data[k].shouldShowRed = true;
                     this.consultationData.chosenDisps[i].data[j].data[k].shouldShowRed = true;
                  }else
                     this.consultationData.chosenDisps[i].data[j].data[k].shouldShowRed = false;
                  flagIndex++;
                  // this.consultationData.chosenDisps[i].data[j].shouldShowRed =
               }
            }else if(chosenDispData.type == "disp-single"){
               if(flattenDisp[flagIndex]["shouldShowRed"])
                  this.consultationData.chosenDisps[i].data[j].details.shouldShowRed =true;
               else
                  this.consultationData.chosenDisps[i].data[j].details.shouldShowRed =false;

               // chosenDispData.details.shouldShowRed = true;
               flagIndex++;
            }
         }
      }
      console.log(this.consultationData.chosenDisps)

   }

   flattenDisp(chosenDisp){
      let result = [];
      for(let i = 0; i< chosenDisp.length; i++){
         if(chosenDisp[i].type == "disp-grouped"){
            for(let j = 0; j< chosenDisp[i].data.length ;j ++){
               let data = chosenDisp[i].data[j];
               result.push({"id": data.id});
            }
         }
         else if(chosenDisp[i].type == "disp-single"){
            result.push({"id": chosenDisp[i].details.id});
         }
      }
      return result;
   }

   /** ----- UI Callbacks ----- **/

   onBackClicked() {

      this.navCtrl.pop();

   }


   onNavBtnClicked(inIdx) {

     this.data.activeTab = inIdx + 1;

     if (inIdx == 0) {
       // push to History and remove this page
       this.navCtrl.push(HistoryPage, { clearData : false }, { animate: false });
       this.navCtrl.remove(this.navCtrl.getViews().length - 2, 1);
     }

   }


   onNextClicked(inMode) {
      let signature = this.modalCtrl.create(SignaturePage, { 'saveMode': inMode, 'handler': this.signHandler }, { enableBackdropDismiss: false });
      signature.present();
   }


   signHandler = (inRes) => {
      return new Promise<void>(resolve => {
         // remove all unnecessary page(s) before pop
         if (this.constants.isEdit) {
            // this.navCtrl.insert( 2, HistoryPage ).then( res => {
            this.navCtrl.remove(2, 1).then(res => {
               this.navCtrl.pop();
               this.consultationData.clearAll();
               this.data.currentStep = 0;
            });
            // });
         }
         else {
            // this.navCtrl.push(HistoryPage, { clearData : false }, { animate: false });
            // this.navCtrl.remove(this.navCtrl.getViews().length - 1, 1);
            
            this.navCtrl.insert(2, HistoryPage).then(res => {
               if (this.navCtrl.getViews().length > 3) {
                  // remove all unnecessary page(s) before pop
                  this.navCtrl.remove(2, this.navCtrl.getViews().length - 3).then(res => {
                     this.navCtrl.pop();
                  });
               }
               else {
                  this.navCtrl.pop();
               }
               // this.navCtrl.remove(3, 2).then(res => {
               //    this.navCtrl.pop();
               //    this.consultationData.clearAll();
               //    this.data.currentStep = 0;
               // });
            });
 
         }
         this.constants.isEdit = false;
         resolve();

      });
   }

   onAcuButtoClick(mode){
      let param = {
        'token': this.data.token,
        'tkt_id': this.data.selectedTicket['tkt_id'],
        'is_start_acu': mode
      }
      // prompt for confirmation
      let onStastAcuConfirm = this.alertCtrl.create({
        title: mode == 1 ? '開始針灸' : '完成針灸',
        subTitle: mode == 1 ? '是否確認開始針灸?' : '是否確認完成針灸?',
        buttons: [
          {
            text: '取消',
            role: 'cancel'
          },
          {
            text: '確認',
            handler: () => {
              let loading = this.modalCtrl.create(LoadingPage, {}, { enableBackdropDismiss: false });
              loading.present();
              // clear all selection
              this.cloudData.acuButtonClicked(param)
                .then(res => {
                  if(res['status'])
                      this.data.selectedTicket = res['result']['ticket'];
                  loading.dismiss();
                })
                .catch(err => {
                  loading.dismiss();
                });
            }
          }
        ],
        enableBackdropDismiss: false
      });
      onStastAcuConfirm.present();
    }







   // nextHandler = ( inRes ) => {
   //
   //    return new Promise( resolve => {
   //
   //       resolve();
   //       if ( inRes[ 'status' ] == true )
   //       {
   //          if ( !this.consultationData.editMode )
   //          {
   //             if ( this.saveMode == 1 )
   //             {
   //                // show print page
   //                let print = this.modalCtrl.create( PrintPage, { 'handler': this.printHandler }, { enableBackdropDismiss: false } );
   //                print.present();
   //             }
   //             else
   //             {
   //                // remove all unnecessary page(s) before pop
   //                this.navCtrl.insert( 2, HistoryPage ).then( res => {
   //
   //                   this.navCtrl.remove( 3, 2 ).then( res => {
   //
   //                      this.navCtrl.pop();
   //                      this.consultationData.clearAll();
   //                      this.data.currentStep = 0;
   //                   });
   //                });
   //             }
   //
   //             // pop back to default ( 'pending' / 'update' )
   //             this.saveMode = 0;
   //          }
   //          else
   //          {
   //             if ( this.saveMode == 1 )
   //             {
   //                // show print page
   //                let print = this.modalCtrl.create( PrintPage, { 'handler': this.printHandler }, { enableBackdropDismiss: false } );
   //                print.present();
   //             }
   //             else
   //             {
   //                // remove all unnecessary page(s) before pop
   //                this.navCtrl.remove( 3, 2 ).then( res => {
   //
   //                   this.navCtrl.pop();
   //                   this.consultationData.clearAll();
   //                   this.data.currentStep = 0;
   //                });
   //             }
   //          }
   //       }
   //       else
   //       {
   //          // prompt for confirmation
   //          let error = this.alertCtrl.create({
   //             title                : '上傳失敗',
   //             subTitle             : '請稍候再試',
   //             buttons              : [
   //                {
   //                   text     : '確認',
   //                   role     : 'cancel'
   //                }
   //             ],
   //             enableBackdropDismiss: false
   //          });
   //          error.present();
   //       }
   //    });
   // }


   printHandler = () => {
      return new Promise<void>(resolve => {
         // remove all unnecessary page(s) before pop
         this.navCtrl.remove(3, 2).then(res => {
            this.navCtrl.pop();
            this.consultationData.clearAll();
            this.data.currentStep = 0;
         });
         resolve();
      });
   }

   showUsageItemPrefix(inIdx, inItemIdx) {
      let zhStr = this.consultationData.chosenDisps[inIdx]['usage'][inItemIdx]['zh'];
      let zhStart = zhStr.indexOf('(');
      let zhEnd = zhStr.indexOf(')');
      if (zhStart > -1 && zhEnd > -1) zhStr = zhStr.substring(0, zhStart);
      return (zhStr);
   }

   showUsageItemDefault(inIdx, inItemIdx) {
      let zhStr = this.consultationData.chosenDisps[inIdx]['usage'][inItemIdx]['zh'];
      let zhStart = zhStr.indexOf('(');
      let zhEnd = zhStr.indexOf(')');
      return (zhStart > -1 && zhEnd > -1) ? this.consultationData.chosenDisps[inIdx]['usage'][inItemIdx]['default'] : '';
   }

   showUsageItemSuffix(inIdx, inItemIdx) {
      let zhStr = this.consultationData.chosenDisps[inIdx]['usage'][inItemIdx]['zh'];
      let zhStart = zhStr.indexOf('(');
      let zhEnd = zhStr.indexOf(')');
      if (zhStart > -1 && zhEnd > -1 && zhEnd + 2 < zhStr.length) {
         return zhStr.substring(zhEnd + 2, zhStr.length);
      }
      else {
         return '';
      }
   }

   getDispGrpById(inId) {
      return this.data.getDispGrpById(inId);
   }

   getDispPillById(inId) {
      return this.data.getDispPillById(inId);
   }

   getAcuGrpById(inId) {
      return this.data.getAcuGrpById(inId);
   }

   getDispSingleById(inId) {
      return this.data.getDispSingleById(inId);
   }
}



// WEBPACK FOOTER //
// ./src/pages/verification/verification.ts